const global = {
  isWeiXin() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == 'micromessenger') {
      // var wechatInfo = navigator.userAgent.match(/MicroMessenger\/([\d\.]+)/i) ;
      // localStorage.setItem("wechatVersion", wechatInfo[1]);
      return true // 是微信端
    } else {
      return false
    }
  },
  deviceOS() {
    const u = navigator.userAgent;
    const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isiOS) {
      return "ios"
    } else {
      return "andriod"
    }
  },
  isKSZ() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("m2osmartcity")>-1) {
      return true
    } else {
      return false
    }
  },
  isSZD() {
    let ua = window.navigator.userAgent.toLowerCase();
    if (ua.indexOf("szd_szgov")>-1) {
      return true
    } else {
      return false
    }
  },
  goNews(id, type) {
    if(global.isKSZ()){
      // 跳看苏州短链
      linkTo(
        JSON.stringify({
          innerLink : "news/NewsDetail?id="+id
        })
      )
    }else{
      if(type == "contentcenter") {
        window.location.href = "https://h5.kan0512.com/ksz/tw/#/article/contentcenter/index?id=" + id
      }else {
        window.location.href = "https://h5.kan0512.com/ksz/tw/#/article/index?id=" + id
      }
      // router.push({
      //   path: "/news",
      //   query: {
      //     id: id
      //   }
      // });
    }
  },
  goTopic(id) {
    window.location.href = "https://h5.kan0512.com/ksz/html/#/topic_style1?id="+id
  },
  goLive(id) {
    if(global.isKSZ()){
      // 跳看苏州短链
      linkTo(
        JSON.stringify({
          innerLink : "tuwen/StudioLiveDetails?id="+id
        })
      )
    }else{
      window.location.href = "https://h5.kan0512.com/ksz/tw/#/live/index?topicid=" + id
    }
  },
  goTuji(id) {
    if(global.isKSZ()){
      // 跳看苏州短链
      linkTo(
        JSON.stringify({
          innerLink : "news/PhotosDetail?id="+id
        })
      )
    }else{
      window.location.href="https://html.kan0512.com/folder611/folder619/2020-06-23/"+id+".html?_hgOutLink=tuji/photosDetail&id="+id
    }
  },
  goVodArticle(id) {
    if(global.isKSZ()){
      // 跳看苏州短链
      linkTo(
        JSON.stringify({
          // innerLink : "tuwen/StudioDetails?id="+id
          innerLink : "news/NewsDetail?id="+id
        })
      )
    }else{
      // window.location.href="http://html.kan0512.com/?_hgOutLink=shortvideo/shortvideoDetail&id=" + id
      window.location.href = "https://h5.kan0512.com/ksz/tw/#/video-article/index?id=" + id
    }
  },
  goJPTV(id) {
    // if(global.isKSZ()){
    //   // 跳看苏州短链
    //   SmartCity.linkTo({
    //     innerLink : "news/PhotosDetail?id="+id
    //   })
    // }else{
      window.location.href="https://html.kan0512.com/?_hgOutLink=tv_play/videoDetail&id="+id
    // }
  },
  //跳转到苏周到专供稿件连接
  goNewsForSZD(id) {
    window.open("https://html.kan0512.com/?_hgOutLink=news_zongrukou/NewsDetail&id="+id)
  },
  // 随机数
  random: function (min, max) {
    return Math.floor(Math.random() * (max - min)) + min
  },
  setCookie(key,value) {
    var exdate = new Date(); //获取时间
    exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * 36500); //保存的天数，我这里写的是100年
    //字符串拼接cookie
    window.document.cookie = key + "=" + value + ";path=/;expires=" + exdate.toGMTString();
  },
  getCookie(param) {
    var c_param = '';
    if (document.cookie.length > 0) {
      var arr = document.cookie.split('; '); //这里显示的格式需要切割一下自己可输出看下
      for (var i = 0; i < arr.length; i++) {
        var arr2 = arr[i].split('='); //再次切割
        //判断查找相对应的值
        if (arr2[0] == param) {
          c_param = arr2[1];
          //保存到保存数据的地方
        }
      }
      return c_param;
    }
  },
  //获取日期到日
  getTimestamp() {
    var tmp = Date.parse(new Date()).toString();
    tmp = tmp.substr(0, 10);
    return tmp;
  },
  // 取6位字母数字随机数
  randomWord() {
    let code = "";
    for (var i = 0; i < 6; i++) {
      var type = global.random(1, 3);
      switch (type) {
        case 1:
          code += String.fromCharCode(global.random(48, 57)); // 数字
          break;
        case 2:
          code += String.fromCharCode(global.random(65, 90)); // 大写字母
          break;
        case 3:
          code += String.fromCharCode(global.random(97, 122)); // 小写字母
          break;
      }
    }
    return code;
  }
}

export default global
